export default {
  segment: {
    height: '550px',
    padding: 0
  },
  map: {
    height: '550px'
  }
};